/* =============================================
   HermanRX Longevity Landing — JS
   ============================================= */
(function () {
    'use strict';

    /* ===========  PARTICLE CANVAS  =========== */
    var canvas = document.getElementById('lg-particles');
    if (canvas) {
        var ctx = canvas.getContext('2d');
        var particles = [];
        var PARTICLE_COUNT = 60;

        function resize() {
            canvas.width = canvas.offsetWidth;
            canvas.height = canvas.offsetHeight;
        }
        resize();
        window.addEventListener('resize', resize);

        for (var i = 0; i < PARTICLE_COUNT; i++) {
            particles.push({
                x: Math.random() * canvas.width,
                y: Math.random() * canvas.height,
                r: Math.random() * 2 + 0.5,
                dx: (Math.random() - 0.5) * 0.3,
                dy: (Math.random() - 0.5) * 0.3,
                o: Math.random() * 0.5 + 0.2
            });
        }

        function drawParticles() {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            for (var j = 0; j < particles.length; j++) {
                var p = particles[j];
                ctx.beginPath();
                ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
                ctx.fillStyle = 'rgba(180, 215, 216, ' + p.o + ')';
                ctx.fill();
                p.x += p.dx;
                p.y += p.dy;
                if (p.x < 0 || p.x > canvas.width) p.dx *= -1;
                if (p.y < 0 || p.y > canvas.height) p.dy *= -1;
            }
            requestAnimationFrame(drawParticles);
        }
        drawParticles();
    }

    /* ===========  STICKY NAV  =========== */
    var nav = document.getElementById('lg-nav');
    if (nav) {
        window.addEventListener('scroll', function () {
            if (window.scrollY > 80) {
                nav.classList.add('scrolled');
            } else {
                nav.classList.remove('scrolled');
            }
        });
    }

    /* ===========  MOBILE NAV  =========== */
    var mobileNav = document.getElementById('lg-nav-mobile');
    var navToggle = document.querySelector('.lg-nav-toggle');
    var mobileClose = document.querySelector('.lg-nav-mobile-close');

    if (navToggle && mobileNav) {
        navToggle.addEventListener('click', function () {
            mobileNav.classList.add('active');
        });
    }
    if (mobileClose && mobileNav) {
        mobileClose.addEventListener('click', function () {
            mobileNav.classList.remove('active');
        });
    }
    // Close mobile nav when clicking a link
    if (mobileNav) {
        var mobileLinks = mobileNav.querySelectorAll('a');
        mobileLinks.forEach(function (link) {
            link.addEventListener('click', function () {
                mobileNav.classList.remove('active');
            });
        });
    }

    /* ===========  SMOOTH SCROLL  =========== */
    document.querySelectorAll('.lg-root a[href^="#"]').forEach(function (link) {
        link.addEventListener('click', function (e) {
            var target = document.querySelector(this.getAttribute('href'));
            if (target) {
                e.preventDefault();
                var offset = nav ? nav.offsetHeight + 16 : 80;
                var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
                window.scrollTo({ top: top, behavior: 'smooth' });
            }
        });
    });

    /* ===========  SCROLL REVEAL  =========== */
    var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add('lg-visible');
                revealObserver.unobserve(entry.target);
            }
        });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.lg-reveal').forEach(function (el) {
        revealObserver.observe(el);
    });

    /* ===========  COUNT-UP ANIMATION  =========== */
    function animateCount(el, target, duration) {
        var start = 0;
        var startTime = null;
        function step(timestamp) {
            if (!startTime) startTime = timestamp;
            var progress = Math.min((timestamp - startTime) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
            var current = Math.round(eased * target);
            el.textContent = current;
            if (progress < 1) {
                requestAnimationFrame(step);
            }
        }
        requestAnimationFrame(step);
    }

    var countObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                var nums = entry.target.querySelectorAll('[data-count]');
                nums.forEach(function (num) {
                    var target = parseInt(num.getAttribute('data-count'), 10);
                    animateCount(num, target, 1500);
                });
                countObserver.unobserve(entry.target);
            }
        });
    }, { threshold: 0.3 });

    // Observe science stats and yellow stats sections
    document.querySelectorAll('.lg-science-stats, .lg-yellow-stats').forEach(function (section) {
        countObserver.observe(section);
    });

    /* ===========  FAQ ACCORDION  =========== */
    document.querySelectorAll('.lg-faq-q').forEach(function (btn) {
        btn.addEventListener('click', function () {
            var item = btn.closest('.lg-faq-item');
            var isOpen = item.classList.contains('active');
            // Close all
            document.querySelectorAll('.lg-faq-item.active').forEach(function (openItem) {
                openItem.classList.remove('active');
                openItem.querySelector('.lg-faq-q').setAttribute('aria-expanded', 'false');
            });
            // Toggle current
            if (!isOpen) {
                item.classList.add('active');
                btn.setAttribute('aria-expanded', 'true');
            }
        });
    });

    /* ===========  SERMORELIN TOGGLE  =========== */
    var sermToggle = document.getElementById('lg-serm-toggle');
    if (sermToggle) {
        var sermBtns = sermToggle.querySelectorAll('.lg-toggle-btn');
        var sermCta = document.getElementById('lg-serm-cta');

        sermBtns.forEach(function (btn) {
            btn.addEventListener('click', function () {
                sermBtns.forEach(function (b) { b.classList.remove('active'); });
                btn.classList.add('active');
                // Update checkout URL
                var url = btn.getAttribute('data-url');
                if (sermCta && url) {
                    sermCta.href = url;
                }
            });
        });
    }

})();
